export function Marquee({ items = [], dark = false }) {
  const list = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${dark ? "border-white/10 bg-ink text-bone" : "border-line bg-bone text-charcoal"} py-5`}
      aria-hidden="true"
    >
      <div className="marquee-track">
        {list.map((it, i) => (
          <span key={i} className="flex items-center font-serif text-2xl md:text-3xl italic font-light tracking-tight whitespace-nowrap">
            <span className="px-6">{it}</span>
            <span className={`inline-block h-1.5 w-1.5 rounded-full ${dark ? "bg-gold" : "bg-terra"}`} />
          </span>
        ))}
      </div>
    </div>
  );
}
